import { createContext, useContext } from "react";
import BasketReducerState from "./types/BasketReducerState";
import BasketReducerAction from "./types/BasketReducerAction";

export const initState: BasketReducerState = {
    event: null,
    groupUsage: {},
    guests: 0,
    maxTickets: 0,
    tickets: [],
    totalPrice: 0,
    totalTickets: 0,
    upsales: [],
    uuid: "",
    view: 0,
};

export const BasketContext = createContext<BasketReducerState>(initState);
export const BasketDispatchContext =
    createContext<React.Dispatch<BasketReducerAction> | null>(null);

export function useBasket() {
    return useContext(BasketContext);
}

export function useBasketDispatch() {
    return useContext(BasketDispatchContext);
}
